import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { VerticalSeparator } from '../../components/separator';
import XIcon from './icons/x-icon';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './toolbar-input.scss';

class ToolbarInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue || '',
    };
  }

  handleChange = event =>
    this.setState({
      value: event.target.value,
    });

  handleKeyDown = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.props.onSubmit(this.state.value);
    }
  };

  handleCancelButtonKeyDown = event => {
    event.preventDefault();
    this.props.onCancel();
  };

  render() {
    const { cardBackgroundColor, contentFontClassName } = this.props;
    const containerClassName = classNames(
      styles.container,
      contentFontClassName,
      'default-forum-card-background-color'
    );
    const style = { backgroundColor: cardBackgroundColor };
    const inputClassName = classNames(styles.input, 'forum-text-color');

    return (
      <div className={containerClassName} style={style}>
        <div className={styles.borders}/>
        <div className={styles.flexContainer}>
          <input
            className={inputClassName}
            type="text"
            placeholder="Paste or type a link..."
            onChange={this.handleChange}
            value={this.state.value}
            onKeyDown={this.handleKeyDown}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
          <VerticalSeparator/>
          <div className={styles.close}>
            <XIcon
              className={classNames(styles.closeIcon, 'forum-icon-fill', 'button-hover-fill')}
              width="12"
              onClick={this.handleCancelButtonKeyDown}
            />
          </div>
        </div>
      </div>
    );
  }
}

ToolbarInput.propTypes = {
  cardBackgroundColor: PropTypes.string,
  contentFontClassName: PropTypes.string,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default _.flowRight(withFontClassName, withCardBackgroundColor)(ToolbarInput);



// WEBPACK FOOTER //
// ./app/components/text-editor/toolbar-input.js